import { InfluencersTabType } from '@anytag/shared-types';
import { XhsInfluencers, XhsInfluencerProfile } from '@anytag/shared-organisms';
import { useSocialAccountSelectButtonProps } from './hooks';

export const XhsInfluencersSearch = () => {
  const { getSortSelectButtonProps, getListSelectButtonProps } =
    useSocialAccountSelectButtonProps<XhsInfluencerProfile>({ socialMedia: InfluencersTabType.XHS });

  return (
    <XhsInfluencers
      getSortSelectButtonProps={getSortSelectButtonProps}
      getListSelectButtonProps={getListSelectButtonProps}
    />
  );
};
